const rate = "rate";
const admin = "/api/admin";
const user = "/api/user";
const gateway = "gateway";
const profile = "profile";
const referral = "referral";
export default {
    //AUTHENTICATIONS
    loggedInUser() {
        return axios.get(`/api/user`);
    },
    userRegistration(data) {
        return axios.post("/api/register", data);
    },

    updateBalance(id, data) {
        return axios.post(`${admin}/user/${id}/balance-update`, data);
    },

    totalUsers() {
        return axios.get(`${admin}/user/deposit/total-users`);
    },

    fundExchange(data) {
        return axios.post(`${user}/deposit/exchange`, data);
    },

    updateProfile(data) {
        return axios.post(`${user}/profile/update`, data);
    },
    //Users
    fetchUsers(data) {
        return axios.get(`${admin}/user`, data);
    },
    fetchAdminUsers(data) {
        return axios.get(`${admin}/user/admins`, data);
    },



    //Gateways
    viewGateways() {
        return axios.get(`${admin}/${gateway}/`);
    },

    createGateway(data) {
        return axios.post(`${admin}/${gateway}/create`, data);
    },
    updateGateway(data, id) {
        return axios.post(`${admin}/${gateway}/update/${id}`, data);
    },
    editGateway(id) {
        return axios.get(`${admin}/${gateway}/edit/${id}`);
    },
    deleteGateway(id) {
        return axios.post(`${admin}/${gateway}/delete/${id}`);
    },


    // User Accounts
    viewAccounts(id) {
        return axios.get(`${user}/${profile}/${id}/accounts`);
    },
    getAccounts() {
        return axios.get(`${user}/${profile}/accounts`);
    },
    passwordUpdate(data) {
        return axios.post(`${user}/${profile}/update-password`, data);
    },

    verifyEmail(data) {
        return axios.post(`${user}/${profile}/verify-email`, data);
    },

    twoFAToggle(data) {
        return axios.post(`${user}/${profile}/toggle-2fa`, data);
    },

    fetchUser(id) {
        return axios.get(`${admin}/user/${id}`);
    },
    userUpdate(id, data) {
        return axios.post(`${admin}/user/${id}/update`, data);
    },
    userStatusUpdate(data, id) {
        return axios.post(`${admin}/user/${id}/update-status`, data);
    },
    userAdminStatusUpdate(data, id) {
        return axios.post(`${admin}/user/${id}/admin-status`, data);
    },

    userDelete(id) {
        return axios.post(`${admin}/user/${id}/delete-user`);
    },

    fetchUserRoles() {
        return axios.get(`${admin}/user/roles`);
    },
    fetchAdminRoles(id) {
        return axios.get(`${admin}/user/${id}/admin-roles`);
    },
    updateBanStatus(id) {
        return axios.get(`${admin}/user/${id}/ban-status`);
    },
    updateTransactionStatus(id) {
        return axios.get(`${admin}/user/${id}/txn-status`);
    },
    updateAccountStatus(id) {
        return axios.get(`${admin}/user/${id}/account-status`);
    },

    adminFetchTransaction(id) {
        return axios.get(`${admin}/transaction/${id}`);
    },
    adminUpdateTransactionStatus(id) {
        return axios.get(`${admin}/transaction/${id}/status`);
    },
    adminCreateTransaction(data) {
        return axios.post(`${admin}/transaction/create`, data);
    },
    adminUpdateTransaction(id, data) {
        return axios.post(`${admin}/transaction/${id}/update`, data);
    },
    adminEditTransaction(id) {
        return axios.get(`${admin}/transaction/${id}/edit`);
    },
    adminGetDashboard() {
        return axios.get(`${admin}/transaction/overview`);
    },
    adminDeleteTransaction(id) {
        return axios.post(`${admin}/transaction/${id}/delete`);
    },
    createSetting(data) {
        return axios.post(`${admin}/settings/create`, data);
    },
    setNotification(data) {
        return axios.post(`${admin}/settings/create`, data);
    },
    viewSettings() {
        return axios.get(`${admin}/settings/`);
    },
    viewRate() {
        return axios.get(`${admin}/settings/rate`);
    },
    deleteSetting(id) {
        return axios.post(`${admin}/settings/delete/${id}`);
    },

    viewRates() {
        return axios.get(`${admin}/${rate}/`);
    },
    updateRate(id, data) {
        return axios.post(`${admin}/${rate}/update/${id}`, data);
    },

    sendEmails(data) {
        return axios.post(`${admin}/email/create`, data);
    },


    adminFetchLoans() {
        return axios.get(`${admin}/loans`);
    },
    adminUpdateLoanStatus(id) {
        return axios.get(`${admin}/loans/${id}/status`);
    },
    adminDeleteLoan(id) {
        return axios.post(`${admin}/loans/${id}/delete`);
    },

    adminFetchCardRequests() {
        return axios.get(`${admin}/card-requests`);
    },
    adminUpdateCardRequestStatus(id) {
        return axios.get(`${admin}/card-requests/${id}/status`);
    },
    adminDeleteCardRequest(id) {
        return axios.post(`${admin}/card-requests/${id}/delete`);
    },

    userCreateTransaction(data) {
        return axios.post(`${user}/transaction/create`, data);
    },
    userCardRequest(data) {
        return axios.post(`${user}/card-requests/create`, data);
    },
    userFetchCards() {
        return axios.get(`${user}/card-requests`);
    },
    userFetchLoans() {
        return axios.get(`${user}/loan-requests`);
    },
    userLoanRequest(data) {
        return axios.post(`${user}/loan-requests/create`, data);
    },
    getTransactions() {
        return axios.get(`${user}/transaction/`);
    },
    sendOTP() {
        return axios.get(`${user}/otp`);
    },
    verifyOTP(data) {
        return axios.post(`${user}/verify-otp`, data);
    },
};
